<template>
  <article class="panel">
    <template v-if="parseInt($store.state.config.user.level) < 99">
      <p class="panel-heading panel-heading-card">Finances V2<a class="button is-success is-small" style="float:right;" @click="showNewCard()" v-if="canShowNewCard">New Card</a></p>
      <p class="panel-block" v-if="parseInt(service.card_payment) === 1">
        <b>Card:</b> XXXX XXXX XXXX {{service.card_client.last4}} - {{service.card_client.brand.toUpperCase()}} <b>Gateway:</b> {{service.card_client.type === 1 ? 'Stripe' : 'WorldPay'}}<br>
        <b>Value:</b> {{service.card_client.value}} {{service.card_client.currency}} <b>Installment:</b> {{service.card_client.installment}}X
      </p>
      <template v-if="(service.invoice_services_v2 && parseInt(service.invoice_services_v2.deleted) != 1 && parseInt(service.invoice_services_v2.dispute) != 1)">
      <p class="panel-block" v-if="((service.status == 'Confirmed') || (service.status === 'PendingCancellation') || (service.status === 'Cancelled') || (parseInt(service.dispute) == 1) || (parseInt(service.invoice_services_v2.invoice.protected) == 1) || (parseInt(service.invoice_services_v2.invoice.deleted) === 1))">
        <tooltip label="History" type="default" placement="top">
          <a class="button button-table is-small" @click="historyInvoice()">
            <i class="fa fa-align-right"></i>
          </a>
        </tooltip>
        <template v-if="parseInt(service.invoice_services_v2.invoice.payment) != 1">
          <tooltip :label="parseInt(service.invoice_services_v2.protected) == 0 ? 'Protect' : 'Unprotect'" type="default" placement="top">
            <a class="button button-table is-small" @click="protectInvoice()">
              <i :class="{'fa': true, 'fa-lock': parseInt(service.invoice_services_v2.invoice.protected) == 0, 'fa-unlock': parseInt(service.invoice_services_v2.invoice.protected) == 1}"></i>
            </a>
          </tooltip>
        </template>
        <b>Invoice:</b> <tooltip :label="service.invoice_services_v2.invoice.deadline" type="default" placement="top"><a v-if="parseInt(service.invoice_services_v2.deleted) != 1 && parseInt(service.invoice_services_v2.dispute) != 1" @click="openInvoice(true)">{{service.invoice_services_v2.invoice.id}}</a></tooltip><label v-if="parseInt(service.invoice_services_v2.invoice.payment) == 1"><b>(Payed)</b> - {{service.invoice_services_v2.invoice.deposit_date | moment('YYYY-MM-DD') }}</label> <label v-if="service.invoice_services_v2.invoice"><b>({{parsePayment(service.invoice_services_v2.invoice.payment)}})</b></label></p>
      </template>
      <template v-if="(service.payment_services_v2) && parseInt(service.payment_services_v2.deleted) != 1 && parseInt(service.payment_services_v2.dispute) != 1">
        <p class="panel-block" v-if="((service.our_status == 'Confirmed') || (service.our_status === 'PendingCancellation') || (service.our_status === 'Cancelled') || (parseInt(service.dispute) == 1) || (parseInt(service.payment_services_v2.payment.protected) == 1) || (parseInt(service.payment_services_v2.payment.deleted) === 1))">
          <tooltip label="History" type="default" placement="top">
            <a class="button button-table is-small" @click="historyPayment()">
              <i class="fa fa-align-right"></i>
            </a>
          </tooltip>
        <template v-if="parseInt(service.payment_services_v2.payment.payment) != 1">
          <tooltip :label="parseInt(service.payment_services_v2.payment.protected) == 0 ? 'Protect' : 'Unprotect'" type="default" placement="top">
            <a class="button button-table is-small" @click="protectPayment()">
              <i :class="{'fa': true, 'fa-lock': parseInt(service.payment_services_v2.payment.protected) == 0, 'fa-unlock': parseInt(service.payment_services_v2.payment.protected) == 1}"></i>
            </a>
          </tooltip>
        </template>
        <b>Payment:</b> <tooltip :label="service.payment_services_v2.payment.deadline" type="default" placement="top"><a v-if="parseInt(service.payment_services_v2.deleted) != 1 && parseInt(service.payment_services_v2.dispute) != 1" @click="openPayment()">{{service.payment_services_v2.payment.id}}</a></tooltip><label v-if="parseInt(service.payment_services_v2.payment.payment) == 1"><b>(Payed)</b> - {{service.payment_services_v2.payment.deposit_date | moment('YYYY-MM-DD')}}</label> <label v-if="service.payment_services_v2.payment"><b>({{parsePayment(service.payment_services_v2.payment.payment)}})</b></label></p>
        <p class="panel-block" v-if="parseInt(service.payment_type) === 'credit card'"><b>{{service.payment_last4}}</b><label>{{service.payment_description}}</label></p>
        <template v-if="service.card">
          <div v-if="(service.payment_type === 'credit card' || service.payment_type === 'pre paid') && !newCard">
            <p class="panel-block align-buttons"><b>Main Card: </b> #{{service.card.id}} - {{service.card.brand}} - {{service.card.card}} - {{service.card.bank}}
            <template v-if="service.service_extend_card">
              <span v-if="service.service_extend_card && service.service_extend_card.vc_status === 'ACTIVE' && service.service_extend_card.tx_status !== 'PENDING' && service.service_extend_card.tx_status !== 'CLEARED' && service.card.vc_card_id === service.service_extend_card.vc_card_id">
                <button class="button is-info is-small" v-if="updateCard === false" @click="showUpdateCard()" >Update Card</button>
                <button class="button is-primary is-small" @click="cancelCardExtend()" >Cancel Card</button>
              </span>
            </template>
            <template v-else>
                <span v-if="service.service_clara_card && service.service_clara_card.vc_card_status === 'ACTIVE'">
                  <!-- <button class="button is-info is-small" v-if="updateCard === false" @click="showUpdateCard()" >Update Card</button> -->
                  <button class="button is-primary is-small" @click="cancelCardClara()" >Cancel Card</button>
                </span>
                  <span v-if="service.service_jeeves_card && service.service_jeeves_card.vc_card_status === 'ACTIVE'">
                  <!-- <button class="button is-info is-small" v-if="updateCard === false" @click="showUpdateCard()" >Update Card</button> -->
                  <button class="button is-primary is-small" @click="deleteCardJeeves()" >Cancel Card</button>
                </span>
            </template>
            </p>
            <p class="panel-block"><b>Virtual Card: </b>{{service.payment_description}}
              <template v-if="service.service_extend_card">
                <span v-if="service.service_extend_card && service.service_extend_card.vc_status === 'CANCELLED' && service.card.vc_card_id === service.service_extend_card.vc_card_id"><b>(CANCELLED)</b></span>
                <span v-if="service.service_extend_card && service.service_extend_card.tx_status === 'CLEARED' && service.card.vc_card_id === service.service_extend_card.vc_card_id"><b>(CLEARED)</b></span>
                <span v-if="service.service_extend_card && service.service_extend_card.tx_status === 'PENDING' && service.card.vc_card_id === service.service_extend_card.vc_card_id"><b>(PENDING)</b></span>
                <span v-if="service.service_extend_card && service.service_extend_card.vc_status === 'EXPIRED' && service.card.vc_card_id === service.service_extend_card.vc_card_id"><b>(EXPIRED)</b></span>
              </template>
              <template v-else-if="service.service_clara_card">
                <span v-if="service.service_clara_card && service.service_clara_card.vc_card_status === 'ACTIVE'"><b>(ACTIVE)</b></span>
                <span v-if="service.service_clara_card && service.service_clara_card.vc_card_status === 'AUTHORIZED'"><b>(AUTHORIZED)</b></span>
                <span v-if="service.service_clara_card && service.service_clara_card.vc_card_status === 'LOCKED'"><b>(LOCKED)</b></span>
                <!--<span v-if="service.service_clara_card && service.service_clara_card.vc_status === 'EXPIRED' && service.card.vc_card_id === service.service_extend_card.vc_card_id"><b>(EXPIRED)</b></span> -->
              </template>
              <template v-else-if="service.service_jeeves_card">
                <span v-if="service.service_jeeves_card && service.service_jeeves_card.vc_card_status === 'ACTIVE'"><b>(ACTIVE)</b></span>
                <span v-if="service.service_jeeves_card && service.service_jeeves_card.vc_card_status === 'AUTHORIZED'"><b>(AUTHORIZED)</b></span>
                <span v-if="service.service_jeeves_card && service.service_jeeves_card.vc_card_status === 'CANCELLED'"><b>(CANCELLED)</b></span>
              </template>
            </p>
            <template v-if="service.service_extend_card">
              <!-- CREATE USER -->
              <p class="panel-block" v-if="service.service_extend_card && service.service_extend_card.vc_create_user_id && !service.service_extend_card.vc_update_user_id && !service.service_extend_card.vc_cancel_user_id && service.card.vc_card_id === service.service_extend_card.vc_card_id"><b>User:</b> {{ service.service_extend_card.user_create.name }} | <b>Created At:</b> {{ service.service_extend_card.vc_created_at }}</p>
              <!-- UPDATE USER -->
              <p class="panel-block" v-if="service.service_extend_card && service.service_extend_card.vc_update_user_id && !service.service_extend_card.vc_cancel_user_id && service.card.vc_card_id === service.service_extend_card.vc_card_id"><b>User:</b> {{ service.service_extend_card.user_update.name }} | <b>Updated At:</b> {{ service.service_extend_card.vc_updated_at }}</p>
              <!-- CANCEL USER -->
              <p class="panel-block" v-if="service.service_extend_card && service.service_extend_card.vc_cancel_user_id && service.card.vc_card_id === service.service_extend_card.vc_card_id"><b>User:</b> {{ service.service_extend_card.user_cancel.name }} | <b>Cancelled At:</b> {{ service.service_extend_card.vc_cancelled_at }}</p>
            </template>
            <template v-else-if="service.service_clara_card">
              <!-- CREATE USER -->
              <p class="panel-block" v-if="service.service_clara_card && service.service_clara_card.vc_create_user_id && !service.service_clara_card.vc_update_user_id && !service.service_clara_card.vc_cancel_user_id"><b>User:</b> {{ service.service_clara_card.user_create.name }} | <b>Created At:</b> {{ service.service_clara_card.vc_created_at }}</p>
              <!-- UPDATE USER -->
              <p class="panel-block" v-if="service.service_clara_card && service.service_clara_card.vc_update_user_id && !service.service_clara_card.vc_cancel_user_id"><b>User:</b> {{ service.service_clara_card.user_update.name }} | <b>Updated At:</b> {{ service.service_clara_card.vc_updated_at }}</p>
              <!-- CANCEL USER -->
              <p class="panel-block" v-if="service.service_clara_card && service.service_clara_card.vc_cancel_user_id"><b>User:</b> {{ service.service_clara_card.user_cancel.name }} | <b>Cancelled At:</b> {{ service.service_clara_card.vc_cancelled_at }}</p>
            </template>
            <template v-else-if="service.service_jeeves_card">
              <!-- CREATE USER -->
              <p class="panel-block" v-if="service.service_jeeves_card && service.service_jeeves_card.vc_create_user_id && !service.service_jeeves_card.vc_update_user_id && !service.service_jeeves_card.vc_cancel_user_id"><b>User:</b> {{ service.service_jeeves_card.user_create.name }} | <b>Created At:</b> {{ service.service_jeeves_card.vc_created_at }}</p>
              <!-- UPDATE USER -->
              <p class="panel-block" v-if="service.service_jeeves_card && service.service_jeeves_card.vc_update_user_id && !service.service_jeeves_card.vc_cancel_user_id"><b>User:</b> {{ service.service_jeeves_card.user_update.name }} | <b>Updated At:</b> {{ service.service_jeeves_card.vc_updated_at }}</p>
              <!-- CANCEL USER -->
              <p class="panel-block" v-if="service.service_jeeves_card && service.service_jeeves_card.vc_cancel_user_id"><b>User:</b> {{ service.service_jeeves_card.user_cancel.name }} | <b>Cancelled At:</b> {{ service.service_jeeves_card.vc_cancelled_at }}</p>
            </template>
            <!-- CHARGES -->
            <div class="panel-block">
              <template v-if="service.service_extend_card">
                <div v-for="charges in service.service_extend_card_charges" :key="charges.id">
                  <div v-for="item in charges.extend_events" :key="item.id">
                    <span v-if="item.event_type === 'transaction.authorized'"><b>Virtual Card:</b> {{ item.vc_last4 }} | <b>Charged At:</b> {{ item.event_date }} <span v-if="service.service_extend_card.tx_status === 'NO_MATCH'"><b>(NO MATCH)</b></span></span>
                    <span v-if="item.event_type === 'transaction.settled'"> <b>Amount:</b> <span v-if="item.tx_type === 'CREDIT'">-</span> {{ item.tx_cleared / 100 }} USD</span>
                  </div>
                </div>
              </template>
              <template v-else-if="service.service_clara_card">
                <!-- {{ service.service_clara_events }} -->
                <div v-for="charge in service.service_clara_events" :key="charge.id">
                  <span v-if="charge.type === 'VIRTUALCARD AUTHORIZED'"><b>Virtual Card:</b> {{ charge.last4 }} | <b>Charged At:</b> {{ charge.created_at | moment('YYYY-MM-DD hh:mm A') }} <b>Amount:</b> {{ charge.charged }} BRL </span>
                </div>
              </template>
              <template v-else-if="service.service_jeeves_card">
                <!-- {{ service.service_jeeves_events }} -->
                <div v-for="charge in service.service_jeeves_events" :key="charge.id">
                  <span v-if="charge.type === 'VIRTUALCARD AUTHORIZED'"><b>Virtual Card:</b> {{ charge.last4 }} | <b>Charged At:</b> {{ charge.created_at | moment('YYYY-MM-DD hh:mm A') }} <b>Amount:</b> {{ charge.charged }} </span>
                </div>
              </template>
            </div>
          </div>
        </template>
        <!-- <template v-else>
            <p class="panel-block" v-if="service.payment_type === 'credit card' && !newCard"><b>Card: </b><label>{{service.payment_description}}</label></p>
        </template> -->
        <p class="panel-block" v-if="newCard">
          <card :service="service" :email="service.room.hotel_info.financial_email" v-on:reload="reload"></card>
        </p>
        <p class="panel-block" v-if="updateCard">
          <card :service="service" :email="service.room.hotel_info.financial_email" :cardType="service.service_extend_card ? 1 : 2" v-on:reload="reload"></card>
        </p>
      </template>
    </template>
    <!-- CLIENT -->
    <template v-else>
      <div class="panel">
        <p class="panel-heading panel-heading-card">Finances<a class="button is-success is-small" style="float:right;" @click="showNewCard()" v-if="((parseInt($store.state.config.user.level) < 4) && ((service.payment_services_v2 != null) && parseInt(service.payment_services_v2.payment.payment) != 1 && parseInt(service.payment_services_v2.deleted) != 1 && parseInt(service.payment_services_v2.dispute) != 1))">New Card</a></p>
        <p class="panel-block" v-if="parseInt(service.card_payment) === 1">
          <b>Card:</b> XXXX XXXX XXXX {{service.card_client.last4}} - {{service.card_client.brand.toUpperCase()}} <b>Gateway:</b> {{service.card_client.type === 1 ? 'Stripe' : 'WorldPay'}}<br>
          <b>Value:</b> {{service.card_client.value}} {{service.card_client.currency}} <b>Installment:</b> {{service.card_client.installment}}X
        </p>
        <template v-if="(service.invoice_services_v2 && parseInt(service.invoice_services_v2.deleted) != 1 && parseInt(service.invoice_services_v2.dispute) != 1)">
        <p class="panel-block" v-if="((service.status == 'Confirmed') || (service.status === 'PendingCancellation') || (service.status === 'Cancelled') || (parseInt(service.dispute) == 1) || (parseInt(service.invoice_services_v2.invoice.protected) == 1) || (parseInt(service.invoice_services_v2.invoice.deleted) === 1))">
          <b>Invoice:</b> <a v-if="parseInt(service.invoice_services_v2.deleted) != 1 && parseInt(service.invoice_services_v2.dispute) != 1" @click="openInvoice(true)">{{service.invoice_services_v2.invoice.id}}</a><label v-if="parseInt(service.invoice_services_v2.invoice.payment) == 1"><b>(Payed)</b> - {{service.invoice_services_v2.invoice.deposit_date | moment('YYYY-MM-DD') }}</label> <label v-if="service.invoice_services_v2.invoice"><b>({{parsePayment(service.invoice_services_v2.invoice.payment)}})</b></label></p>
        </template>
      </div>
    </template>
    <!-- CLIENT -->
  </article>
</template>
<script>
  import Invoice from '../../finances/V2/invoice/invoice'
  import Payment from '../../finances/V2/payment/payment'
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../../utils/message'
  import Card from '../Card.vue'
  export default {
    data () {
      return {
        service_history: null,
        load_service_old_history: false,
        reload_history: false,
        related: [],
        newCard: false,
        updateCard: false,
        card_type: 1,
        charged_cards: {
          vc_last4: [],
          event_date: [],
          tx_cleared: [],
          counter: 0
        }
      }
    },
    props: {
      service: {
        type: Object,
        default: null
      }
    },
    components: {
      Tooltip,
      Card
    },
    computed: {
      canShowNewCard () {
        // Permissions
        const hasPermission = parseInt(this.$store.state.config.user.level) < 4
        const hasPaymentService = this.service.payment_services_v2 != null
        const paymentNotPaid = this.service.payment_services_v2 && this.service.payment_services_v2.payment && parseInt(this.service.payment_services_v2.payment.payment) !== 1
        const paymentNotDeleted = this.service.payment_services_v2 && parseInt(this.service.payment_services_v2.deleted) !== 1
        const paymentNotDispute = this.service.payment_services_v2 && parseInt(this.service.payment_services_v2.dispute) !== 1
        // Verificação de cartão ativo
        const hasActiveExtend = this.service.service_extend_card && this.service.service_extend_card.vc_status === 'ACTIVE'
        const hasActiveClara = this.service.service_clara_card && this.service.service_clara_card.vc_card_status === 'ACTIVE'
        const hasActiveJeeves = this.service.service_jeeves_card && this.service.service_jeeves_card.vc_card_status === 'ACTIVE'
        const cardIsInactive = !hasActiveExtend && !hasActiveClara && !hasActiveJeeves
        return hasPermission && hasPaymentService && paymentNotPaid && paymentNotDeleted && paymentNotDispute && cardIsInactive
      }
    },
    mounted () {
      this.$nextTick(() => {
        // this.loadData()
      })
    },
    methods: {
      reload () {
        // this.loadData()
        // this.reloadHistory()
        this.newCard = false
      },
      historyInvoice () {
        let propsData = {
          context: this,
          invoice_id: this.service.invoice_services_v2.invoice_id,
          callback: ''
        }
        Invoice.openHistoryInvoice(propsData)
      },
      historyPayment () {
        let propsData = {
          context: this,
          payment_id: this.service.payment_services_v2.payment_id,
          callback: ''
        }
        Payment.openHistoryPayment(propsData)
      },
      cancelCardExtend () {
        if (window.confirm('Are you sure you want to CANCEL this Virtual Card?')) {
          this.$http.post(this.$store.state.config.apiURL + '/services/' + this.service.id + '/cancel_card_extend', {vc_id: this.service.vc_id}).then((response) => {
            if (response.body === 'Error') {
              this.message('danger', 'Error', 'The system was not able to cancel the card. Try again in a few seconds.')
            } else {
              this.message('success', 'Success', 'The extend card has been successfully cancelled')
              setTimeout(() => {
                window.location.reload()
              }, 3000)
            }
          }, (response) => {
            this.message('danger', 'Error', response.body)
          })
        }
      },
      cancelCardClara () {
        if (window.confirm('Are you sure you want to CANCEL this Virtual Card?')) {
          this.$http.post(this.$store.state.config.apiURL + '/services/' + this.service.id + '/cancel_card_clara', {clara_uuid: this.service.clara_uuid}).then((response) => {
            if (response.body === 'Error') {
              this.message('danger', 'Error', 'The system was not able to cancel the card. Try again in a few seconds.')
            } else {
              this.message('success', 'Success', 'The Clara Card has been successfully cancelled')
              setTimeout(() => {
                window.location.reload()
              }, 3000)
            }
          }, (response) => {
            this.message('danger', 'Error', response.body)
          })
        }
      },
      deleteCardJeeves () {
        if (window.confirm('Are you sure you want to DELETE this Virtual Card?')) {
          this.$http.post(this.$store.state.config.apiURL + '/services/' + this.service.id + '/delete_card_jeeves', {jeeves_vc_id: this.service.vc_id}).then((response) => {
            if (response.body === 'Error') {
              this.message('danger', 'Error', 'The system was not able to delete the card. Try again in a few seconds.')
            } else {
              this.message('success', 'Success', 'The Jeeves Card has been successfully deleted')
              setTimeout(() => {
                window.location.reload()
              }, 3000)
            }
          }, (response) => {
            this.message('danger', 'Error', response.body)
          })
        }
      },
      showNewCard () {
        this.newCard = true
      },
      showUpdateCard () {
        this.updateCard = true
      },
      parsePreMethod (method) {
        let payment = ''
        switch (parseInt(method)) {
          case 0: {
            payment = 'Unpaid'
            break
          }
          case 1: {
            payment = 'Card'
            break
          }
          case 2: {
            payment = 'Invoice'
            break
          }
          case 3: {
            payment = 'Commission'
            break
          }
          case 4: {
            payment = 'Transfer'
            break
          }
          case 5: {
            payment = 'Pre-payment'
            break
          }
          case 6: {
            payment = 'Credit'
            break
          }
          case 7: {
            payment = 'No rule'
            break
          }
        }
        return payment
      },
      openInvoice () {
        let propsData = {
          context: this,
          invoice_id: this.service.invoice_services_v2.invoice.id,
          edit: true,
          callback: ''
        }
        Invoice.openInvoice(propsData)
      },
      openPayment () {
        let propsData = {
          context: this,
          payment_id: this.service.payment_services_v2.payment.id,
          edit: true,
          callback: ''
        }
        Payment.openPayment(propsData)
      },
      protectInvoice () {
        this.$http.post(this.$store.state.config.apiURL + '/V2/invoice/protect', {invoices: [this.service.invoice_services_v2.invoice.id]}).then((response) => {
          let propsData = {
            title: 'Success',
            message: 'The invoice protection has been applied',
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }

          message.openMessage(propsData)
          this.$root.$emit('reloadservice', true)
          this.$root.$emit('reloadoccurrence', true)
        }, (response) => {
          this.message('danger', 'Error', response.body)
        })
      },
      protectPayment () {
        this.$http.post(this.$store.state.config.apiURL + '/V2/payment/protect', {payments: [this.service.payment_services_v2.payment.id]}).then((response) => {
          let propsData = {
            title: 'Success',
            message: 'The payment protection has been applied',
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
          this.$root.$emit('reloadservice', true)
          this.$root.$emit('reloadoccurrence', true)
        }, (response) => {
          this.message('danger', 'Error', response.body)
        })
      },
      view (id) {
        this.$router.replace({name: 'Service', params: {id: id}})
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      parsePayment (content) {
        let payment = ''
        switch (parseInt(content)) {
          case 0: {
            payment = 'Unpaid'
            break
          }
          case 1: {
            payment = 'Paid'
            break
          }
          case 2: {
            payment = 'Billed'
            break
          }
          case 3: {
            payment = 'Pending'
            break
          }
          case 4: {
            payment = 'Legal Pending'
            break
          }
        }
        return payment
      }
    }
  }
</script>

<style lang="scss" scoped>
.is-title {
  text-transform: capitalize;
}

.panel {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
  color: #4a4a4a;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: flex;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
  background-color: rgb(167, 28, 32);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel-success {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(35, 209, 96), 0px 0px 0px 1px rgb(35, 209, 96);
  color: #23d160;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading-success {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: block;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(35, 209, 96), 0px 0px 0px 0px rgb(35, 209, 96);
  background-color: rgb(35, 209, 96);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel-heading-card {
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: block;
  min-height: 40px;
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel-info {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(50, 115, 220), 0px 0px 0px 1px rgb(50, 115, 220);
  color: #3273dc;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading-info {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: flex;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(50, 115, 220), 0px 0px 0px 0px rgb(50, 115, 220);
  background-color: rgb(50, 115, 220);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel-warning {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(255, 221, 87), 0px 0px 0px 1px rgb(255, 221, 87);
  color: #ffdd57;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading-warning {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: block;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(255, 221, 87), 0px 0px 0px 0px rgb(255, 221, 87);
  background-color: rgb(255, 221, 87);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

pre {
  background-color: #FFFFFF;
  white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
  white-space: -pre-wrap; /* Opera */
  white-space: -o-pre-wrap; /* Opera */
  white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
  word-wrap: break-word; /* IE 5.5+ */
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
  color: #4a4a4a;
  font-size: 1rem;
  font-weight: 400;
}

.align-buttons {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// Finances.vue?0afccee9